import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// CREATE
export const createFloorMapApi = (data) => {
  return API.post("/floor-map", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// GET
export const getFloorMapsApi = (params) => {
  return API.get("/floor-map", { params });
};

// DELETE
export const deleteFloorMapApi = (id) => {
  return API.delete(`/floor-map/${id}`);
};

// UPDATE
export const updateFloorMapApi = (id, data) => {
  return API.put(`/floor-map/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};